module.exports = __webpack_public_path__ + "img/team.png";